import AboutUs from '@/modules/Dashboard/pages/AboutUs.tsx';
import HomePage from '@/modules/Dashboard/pages/HomePage';
import SidebarSignaturePage from '@/modules/Dashboard/pages/SidebarSignaturePage.tsx';
import { RouteObject } from 'react-router-dom';
import {
  ABOUT_US_PATH,
  SIGNATURE_PATH,
  WALLET_PATH,
  YEARLY_REPORT,
} from './DashboardLinks';
import Wallet from './pages/Wallet';
import WalletYearlyReportPage from './pages/WalletYearlyReportPage';

export const DashboardRoutes: RouteObject[] = [
  {
    index: true,
    element: <HomePage />,
  },

  {
    path: ABOUT_US_PATH,
    element: <AboutUs />,
  },
  {
    path: SIGNATURE_PATH,
    element: <SidebarSignaturePage />,
  },
  {
    path: WALLET_PATH,
    children: [
      {
        index: true,
        element: <Wallet />,
      },
      {
        path: YEARLY_REPORT,
        element: <WalletYearlyReportPage />,
      },
    ],
  },
];
